export default __webpack_public_path__ + "img/5d55ba5d60a99d44ac91b436f96cee70.png";